/* eslint-disable no-useless-escape */
import { castArray, isPlainObject, transform } from 'lodash'
import escapeStringRegexp from 'escape-string-regexp'

export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] == value)
}

export function not(predicate) {
  return function negated(...args) {
    return !predicate(...args)
  }
}

export function slugify(text, replacements = []) {
  let string = text

  for (const [key, value] of replacements) {
    string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value)
  }

  string = string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text

  return string
}

export function slugifyProductName(name) {
  switch (name) {
    case 'Private Party':
      name = 'Private Party Vaginal Probiotic'
      break
    case 'Über Energy':
      name = 'Uber Energy'
      break
    default:
      break
  }
  return slugify(name)
}

export function normalize(key) {
  return key.toString().toLowerCase().split('-').join(' ')
}

export function stripKeys(obj = {}, keys, deep = false) {
  keys = castArray(keys)

  return transform(
    obj,
    (acc, value, key) => {
      if (keys.includes(key)) {
        return
      }

      acc[key] =
        deep && isPlainObject(value) ? stripKeys(value, keys, deep) : value
    },
    {}
  )
}

export function timer(ms) {
  return new Promise(resolve => setTimeout(resolve, Number(ms)))
}

export function isInTestGroup(testGroups = [], [testId, variantId]) {
  const testGroup = testGroups.find(group => group.test_id == testId) || false

  return Boolean(testGroup && testGroup.group_id == variantId)
}

export function registerStoreModule({ module, moduleName, store }) {
  const moduleIsRegistered =
    store._modules.root._children[moduleName] !== undefined
  const stateExists = store.state[moduleName] !== undefined

  if (!moduleIsRegistered) {
    store.registerModule(moduleName, module, { preserveState: stateExists })
  }
}

export const wait = (sec = 0, cb) =>
  new Promise(resolve => setTimeout(resolve(cb), sec * 1000))

export function localStorageIsSupported() {
  const test = 'test'
  try {
    window.localStorage.setItem(test, test)
    window.localStorage.removeItem(test)

    return true
  } catch (e) {
    return false
  }
}

export function copyToClipboard(content) {
  const textArea = document.createElement('textarea')
  textArea.height = '0px'
  textArea.opacity = '0'
  textArea.value = content
  document.body.appendChild(textArea)
  textArea.select()
  document.execCommand('copy')

  document.body.removeChild(textArea)
}
